import { Grid, Tooltip, Typography, styled } from "@mui/material";
import { range } from "lodash";
import { useEffect } from "react";
import PageTemplate from "../../components/template/page-template";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";
import FAQSection from "../faq/components/faq-section";
import SectionNavigation from "./components/section-navigation";
import { faqActions } from "./redux";

export const FAQPage = ({ className }: IWithClassName) => {
    const { data, isLoading } = useAppSelector(({ faq }) => faq);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(faqActions.init());
    }, [dispatch]);

    return (
        <PageTemplate pageTitle="FAQ" className={className}>
            <Grid container>
                <Tooltip
                    title={
                        "This page is designed to provide quick and easy answers to common" +
                        " questions that users may have about the POI product and its tools."
                    }
                >
                    <Typography className="title" component="h6">
                        FAQ
                    </Typography>
                </Tooltip>
            </Grid>
            <SectionNavigation links={data ?? []} isLoading={isLoading} />
            {isLoading
                ? range(2).map((idx) => (
                      <FAQSection
                          key={idx}
                          title={idx.toString()}
                          slug={idx.toString()}
                          faqs={[{}, {}]}
                          isLoading={isLoading}
                      />
                  ))
                : data?.map(({ questions, slug, title }) => (
                      <FAQSection
                          key={slug}
                          title={title}
                          slug={slug}
                          faqs={questions}
                          isLoading={isLoading}
                      />
                  ))}
        </PageTemplate>
    );
};
export default styled(FAQPage)(({ theme }: IWithThemeProps) => ({
    marginBottom: theme?.spacing(1),
    ".title": {
        fontSize: 20,
        marginBottom: theme?.spacing(4),
        fontWeight: 600,
        textTransform: "uppercase",
    },
}));
